export default {
    common: {
        datepicker: {
            months: {
                july: 'Luglio',
                september: 'Settembre',
                april: 'Aprile',
                march: 'Marzo',
                may: 'Maggio',
                february: 'Febbraio',
                june: 'Giugno',
                january: 'Gennaio',
                november: 'Novembre',
                october: 'Ottobre',
                august: 'Agosto',
                december: 'Dicembre',
            },
            days: {
                tuesday: 'Mar',
                thursday: 'Gio',
                saturday: 'Sab',
                wednesday: 'Mer',
                monday: 'Lun',
                friday: 'Ven',
                sunday: 'Dom',
            },
        },
        label: {
            insured: 'Assicurato',
            selected: 'Selezionato',
            noValue: 'Nessuna informazione disponibile',
            cancel: 'Annullare',
            bestseller: 'Bestseller',
            moreDetails: 'Dettagli',
            next: 'Avanti',
            no: 'No',
            ok: 'Ok',
            choose: 'Selezionare',
            to: 'di',
            notInsured: 'Non assicurato',
            back: 'Indietro',
            save: 'Salvare',
            edit: 'Modificare',
            yes: 'Sì',
        },
        unsavedData: {
            message: 'In questa pagina sono presenti dati non salvati. Ricaricare la pagina?',
        },
        technicalError: {
            actionText: 'Riprovare',
            message: 'A causa di un errore tecnico, la tua richiesta non è stata elaborata. Per favore riprova più tardi.',
        },
        invalidForm: {
            message: 'I dati inseriti sono incompleti o non validi. Si prega di verificare i dati inseriti e di riprovare.',
        },
    },
    summaryStep: {
        insurance: {
            title: 'Copertura assicurativa selezionata',
            subtitle: 'Prestazioni incluse (dettagli e spiegazioni sono disponibili nella panoramica delle prestazioni) ',
        },
        share: {
            label: 'Inoltrare tramite e-mail',
            heading: 'Inoltrare, elaborare più tardi o stampare',
            send: {
                label: 'Inviare',
            },
            subtitle: 'Questo riepilogo può essere inviato tramite e-mail. I dati inseriti sono registrati e possono essere integrati o modificati in un secondo momento. Inoltre è possibile anche stampare il riepilogo dei dati.',
            toast: {
                success: 'L’e-mail con il link è stata inviata.',
                failed: 'Purtroppo non è stato possibile inviare l’e-mail!',
            },
        },
        contact: {
            phone: {
                label: 'Telefono',
            },
            mail: {
                label: 'E-mail di conferma',
            },
            title: 'Dati di contatto del contraente',
        },
        construction: {
            title: 'Progetto di costruzione',
            sum: {
                label: 'Importo',
            },
            duration: {
                label: 'Periodo dei lavori',
            },
        },
        title: 'Riepilogo',
        advisor: {
            title: 'Dati intermediario',
            mail: {
                label: 'E-Mail del intermediario',
            },
        },
        risks: {
            title: 'Criteri',
        },
        print: {
            title: 'Assicurazione costruzioni',
            label: 'Stampare il riepilogo',
        },
        submit: {
            hint: 'La copertura d\'assicurazione inizia a partire dalla data di inizio della vostra costruzione registrata online.',
            label: 'Acquista ora',
        },
        edit: {
            toast: {
                message: 'Il premio è stato calcolato di nuovo!',
            },
        },
        avb: {
            label: '<ul style="list-style: disc;"> <li> Confermo di aver letto le <a href="https://www.baloise.ch/dam/baloise-ch/unternehmenskunden/documents/it/vertragsbedingungen/156_1009.pdf" target="_blank">informazioni sul prodotto</a> e l’<a href="https://www.baloise.ch/it/chi-siamo/informazioni/protezione-dei-dati.html" target="_blank">informativa sulla  protezione dei dati per contratti di assicurazione</a> e accetto le <a href="https://www.baloise.ch/dam/baloise-ch/unternehmenskunden/documents/it/vertragsbedingungen/156_1009.pdf" target="_blank">condizioni  contrattuali generali</a> e autorizzo Baloise a <a href="https://www.baloise.ch/dam/baloise-ch/applications/praemienrechner/hh/Procura-per-ottenere-informazioni-da-terzi.pdf" target="_blank">richiedere informazioni di terzi.</a> </li> <li>Confermo di aver risposto a tutte le domande in modo veritiero.</li> </ul>', 
            label_fl: '<ul style="list-style: disc;"> <li> Confermo di aver letto le <a href="https://www.baloise.ch/dam/baloise-ch/unternehmenskunden/documents/it/vertragsbedingungen/156_1009.pdf" target="_blank">informazioni sul prodotto</a> e l’<a href="https://www.baloise.ch/it/chi-siamo/informazioni/protezione-dei-dati.html" target="_blank">informativa sulla  protezione dei dati per contratti di assicurazione</a> e accetto le <a href="https://www.baloise.ch/dam/baloise-ch/unternehmenskunden/documents/it/vertragsbedingungen/156_1009.pdf" target="_blank">condizioni  contrattuali generali</a> e autorizzo Baloise a <a href="https://www.baloise.ch/dam/baloise-ch/applications/praemienrechner/hh/Procura-per-ottenere-informazioni-da-terzi.pdf" target="_blank">richiedere informazioni di terzi.</a> </li> <li>Confermo di aver risposto a tutte le domande in modo veritiero.</li> <li>Esonero Baloise dal <a href="https://www.baloise.ch/dam/baloise-ch/applications/praemienrechner/hh/Segreto-commerciale-nel-Liechtenstein.pdf" target="_blank">segreto commerciale previsto nel Liechtenstein.</a></li> <li> Accetto le <a href="https://www.baloise.ch/dam/baloise-ch/applications/praemienrechner/cyber/000_1362_i.pdf" target="_blank">disposizioni supplementari per contratti secondo la legislazione del  Liechtenstein</a> e confermo di aver preso atto del <a href="https://www.baloise.ch/dam/baloise-ch/unternehmenskunden/documents/de/IPID/156_1025_d.pdf" target="_blank">documento informativo relativo al  prodotto assicurativo (IPID).</a> </li> </ul>',
        },
        dp: {
            text: 'Con la trasmissione dei dati acconsente al trattamento della richiesta. Il consenso può essere revocato in qualsiasi momento. Ulteriori informazioni in merito al trattamento dei dati sono contenute nella nostra <a href="https://www.baloise.ch/it/chi-siamo/informazioni/protezione-dei-dati.html" target="_blank">informativa sulla protezione dei dati</a>.',
        },
    },
    matrixStep: {
        liability: {
            visitor: {
                label: 'Infortunio di visitatori',
            },
            personAndPropertyDamage: {
                label: 'Prestazione massima (garanzia unica per l’intera durata contrattuale)',
            },
            label: 'Responsabilità civile del committente',
            doubleGuaranty: {
                label: 'Garanzia doppia (la somma assicurata è a disposizione due volte)',
            },
            legalProtectionAndFinancialLosses: {
                label: 'Danni meramente patrimoniali e protezione giuridica in caso di procedimento penale, per ogni copertura',
            },
        },
        construction: {
            earthquake: {
                label: 'Terremoti ed eruzioni vulcaniche',
            },
            base: {
                tooltip: 'La copertura di base comprende danni materiali imprevisti che si sono verificati durante i lavori sull’opera in fase di realizzazione ma non ancora ultimata. Furto di cose montate o installate.',
                label: 'Copertura di base',
            },
            addition: {
                one: {
                    label: 'Mobilio, spese di perizia e di accertamento del danno, danni da acqua agli stabili, per ogni copertura',
                },
                label: 'Copertura supplementare',
                two: {
                    label: 'Graffi su superfici in vetro, spese supplementari per lavoro straordinario e trasporto aereo, ritardi nella costruzione e interruzione, per ogni copertura',
                },
                tooltip: 'La copertura supplementare comprende, tra l\'altro, materiali d’impalcatura, di sbadacchiaturae e altro materiale, scarpate e terreno, costruzioni esistenti, mobilio, attrezzi, utensili, macchine edili e attrezzatura.',
                three: {
                    label: 'Furto con scasso di oggetti non fissati alle opere o agli stabili',
                },
            },
            label: 'Lavori di costruzione',
        },
        quote: {
            label: 'Premio unico in CHF',
            stampDuty: {
                label: 'compresa la tassa di bollo',
            },
        },
        details: {
            link: 'https://www.baloise.ch/dam/baloise-ch/unternehmenskunden/documents/it/factsheets/Schede-informative_Assicurazioni-costruzione.pdf',
            label: 'Il presente riepilogo fornisce unicamente un quadro generale. Per tutti i dettagli e le spiegazioni rimandiamo alla <a href="https://www.baloise.ch/dam/baloise-ch/unternehmenskunden/documents/it/factsheets/Schede-informative_Assicurazioni-costruzione.pdf" target="_blank">panoramica delle prestazioni</a>.',
        },
        deductible: {
            hint: 'per lavori di costruzione e responsabilità civile del committente',
            label: 'Franchigia',
        },
        additionalLimit: {
            hint: 'per lavori di costruzione e responsabilità civile del committente',
            label: 'Doppia garanzia',
            singleGuarantee: '-',
            doubleGuarantee: 'Assicurato',
        },
        title: 'Selezionare la copertura assicurativa ottimale',
    },
    typeStep: {
        constructionType: {
            apartmentHouse: {
                label: 'Casa plurifamiliare',
            },
            altLink: {
                text: 'Se non è possibile trovare il tipo di costruzione desiderato,',
                alt: 'proseguire qui.',
                url: 'https://www.baloise.ch/it/clienti-aziendali/assicurare/responsabilita-civile-diritto-valori-materiali/costruzione/assicurazione-costruzione/richiesta-di-offerta-assicurazione-costruzioni-1.html',
            },
            industrialBuilding: {
                label: 'Stabile commerciale',
            },
            commerceAndLiving: {
                label: 'Edificio ad uso abitativo e commerciale',
            },
            detachedHouse: {
                label: 'Casa unifamiliare',
            },
            title: 'Selezionare il proprio tipo di costruzione',
            validation: {
                message: 'Selezionare il proprio tipo di costruzione.',
            },
        },
        constructionKind: {
            renovation: {
                tooltip: 'Nel caso in cui in un edificio vengano eseguiti dei lavori senza modifiche agli elementi portanti (ad es. demolizione di una parete portante) o senza interventi sul tetto, selezionare riattazione.',
                label: 'Trasformazione/ristrutturazione',
            },
            newBuilding: {
                tooltip: 'Nel caso in cui venga costruito un nuovo edificio oppure ampliato o trasformato un edificio esistente, selezionare nuova costruzione/ampliamento/trasformazione.',
                label: 'Nuova costruzione/ampliamento',
            },
            title: 'Selezionare il proprio progetto di costruzione',
        },
    },
    riskStep: {
        supportStructureChanged: {
            tooltip: 'In caso di risposta negativa, partiamo dal presupposto che si tratti di una riattazione.',
            label: 'Vengono modificati elementi portanti (ad es. pareti, soffitti, balconi) o vengono fatti lavori al tetto?',
        },
        underpinning: {
            tooltip: 'Sottomurazione e/o sottopasso di opere e/o parti di stabili di terzi (ad esempio edifici, muri di sostegno, canali, impianti ferroviari)',
            label: 'Vengono realizzati dei lavori di sottomurazione e/o di sottopasso di parte di stabili/opere di terzi?',
        },
        groundwater: {
            label: 'Il livello della falda freatica viene abbassato?',
            tooltip: 'Abbassamento del livello della falda freatica entro il rivestimento di uno scavo chiuso oppure al di fuori dello scavo stesso (un impianto di drenaggio a cielo aperto non è considerato un abbassamento del livello della falda)',
        },
        dangerZone: {
            warning: 'Poiché il progetto di costruzione si trova in una zona a rischio, non è possibile calcolare il premio online. Siamo tuttavia lieti di sottoporvi un’offerta e vi preghiamo di contattarci a tal fine al <a target="_blank" href="https://www.baloise.ch/it/clienti-aziendali/assicurare/responsabilita-civile-diritto-valori-materiali/costruzione/assicurazione-costruzione/richiesta-di-offerta-assicurazione-costruzioni-1.html"> modulo</a>.',
            label: 'Il progetto di costruzione si trova in una zona di pericolo con un rischio medio o notevole di piene,  terreno in movimento, frane, caduta di sassi, valanghe o c’è un rischio di deflusso superficiale (profondità dell\'acqua ≥25 cm)?',
            tooltip: 'Per la valutazione sono determinanti le mappe dei pericoli dei cantoni, del Principato del Liechtenstein, dell\'Associazione degli istituti cantonali di assicurazione (AICA) e dell\'Associazione Svizzera d’Assicurazioni (ASA). Se i pericoli sono stati valutati in modo diverso nella perizia geologica, queste valutazioni sono determinanti.',
        },
        ram: {
            label: 'Pali, palancole o profili metallici vengono battuti, trivellati o vibrati nel terreno?',
        },
        rock: {
            label: 'Vengono eseguiti dei lavori di sbancamento di roccia  (distruzione di rocce con esplosivi, martelli idraulici o scalpelli)?',
        },
        newConstruction: {
            label: 'Viene costruito un nuovo edificio o un ampliamento?',
        },
        title: 'Altre domande sul progetto di costruzione',
    },
    success: {
        title: 'Grazie!',
        lead: 'Abbiamo ricevuto i dati.<br>Invieremo a breve la documentazione contrattuale.<br>In caso di domande siamo raggiungibili al E-mail <a target="_blank" href="mailto:easyconstruct@baloise.ch">easyconstruct@baloise.ch</a>.',
    },
    contactStep: {
        birthdate : {
            label: 'Data di nascita',
        },
        street: {
            validation: {
                message: 'Inserire una via valida.',
            },
            placeholder: 'Via e numero civico',
        },
        title: 'Siamo quasi arrivati alla fine!',
        lastName: {
            placeholder: 'Cognome',
            validation: {
                message: 'Inserire un cognome valido.',
            },
        },
        languageOfCorrespondence: {
            de: 'Tedesco',
            label: 'Lingua di corrispondenza',
            fr: 'Francese',
            it: 'Italiano',
        },
        postcode: {
            placeholder: 'NPA',
            validation: {
                message: 'Inserire un numero postale di avviamento valido.',
            },
        },
        city: {
            validation: {
                message: 'Inserire un luogo valido.',
            },
            placeholder: 'Luogo',
        },
        firstName: {
            placeholder: 'Nome',
            validation: {
                message: 'Inserire un nome valido.',
            },
        },
        subtitle: {
            email: 'A chi deve essere inviata la conferma?',
            contact: 'Dati di contatto del contraente',
        },
        salutation: {
            validation: {
                message: 'Selezionare un appellativo.',
            },
            female: 'Signora',
            male: 'Signor',
            company: 'Azienda',
        },
        phone: {
            validation: {
                message: 'Inserire un numero di telefono valido.',
            },
            placeholder: 'Telefono',
        },
        advisor: {
            placeholder: 'Se è stato un intermediario a offrire l’assicurazione, indicarne qui il nome e il numero di intermediario (ad es. architetto, broker, ecc.)',
            label: 'Dati intermediario (facoltativo)',
            contactStep: {},
        },
        advisorMail: {
            placeholder: 'E-Mail del intermediario (opzionale)',
        },
        email: {
            placeholder: 'E-Mail del contraente',
            validation: {
                message: 'Inserire un indirizzo e-mail valido.',
            },
        },
        companyName: {
            placeholder: 'Azienda',
            validation: {
                message: 'Inserire un nome dell’azienda valido.',
            },
        },
        next: 'Proseguire al riepilogo',
    },
    whenStep: {
        startDate: {
            title: 'Quando iniziano i lavori di costruzione?',
            validation: {
                message: 'Selezionare una data valida.',
            },
            tooltip: 'La copertura assicurativa inizia al più presto con la conclusione del contratto.',
            placeholder: 'Inizio dei lavori',
        },
        completionDate: {
            validation: {
                message: 'Selezionare il periodo di tempo.',
            },
            title: 'Fino a quando costruisci?',
            year: 'anno',
            placeholder: 'Fine dei lavori',
            upTo: 'Fino a',
            tooltip: 'Se il progetto edile ha una durata di oltre 3 anni, <a target="_blank" href="https://www.baloise.ch/it/clienti-aziendali/assicurare/responsabilita-civile-diritto-valori-materiali/costruzione/assicurazione-costruzione/richiesta-di-offerta-assicurazione-costruzioni-1.html">proseguire qui.</a>',
            years: 'anni',
        },
        title: 'Periodo dei lavori',
    },
    whereStep: {
        postcode: {
            placeholder: 'NPA',
            label: '',
            validation: {
                message: 'Inserire un numero postale di avviamento valido.',
            },
        },
        street: {
            label: '',
            validation: {
                message: 'Inserire un indirizzo valido.',
            },
            placeholder: 'Via e numero civico o numero di parcella',
        },
        city: {
            validation: {
                message: 'Inserire un luogo valido.',
            },
            placeholder: 'Luogo',
            dropDownLabel: 'Prego selezionare',
            label: '',
        },
        title: 'Dove si svolgono i lavori?',
    },
    fail: {
        lead: 'Vi preghiamo di riprovare più tardi o di contattarci al E-mail <a target="_blank" href="mailto:easyconstruct@baloise.ch">easyconstruct@baloise.ch</a>.',
        title: 'Si è verificato un errore.',
    },
    sumStep: {
        sum: {
            info: {
                text1: 'Per determinare l’importo di costruzione sommare le posizioni 1-4 del codice dei costi di costruzione (incl. IVA, onorari e prestazioni proprie del committente).',
                text2: 'Non rientrano nell’importo di costruzione spese relative a studi preliminari, gare, acquisto del terreno, urbanizzazione primaria, finanziamento e tasse.',
                text3: 'Se l’importo di costruzione è superiore a CHF 10\'000\'000,  <a target="_blank" href="https://www.baloise.ch/it/clienti-aziendali/assicurare/responsabilita-civile-diritto-valori-materiali/costruzione/assicurazione-costruzione/richiesta-di-offerta-assicurazione-costruzioni-1.html">proseguire qui.</a>',
                title: 'Come si calcola l’importo di costruzione?',
            },
            label: 'CHF',
            placeholder: '500\'000',
            validation: {
                message: 'L’importo di costruzione deve essere di almeno CHF 10\'000 e al massimo di CHF 10 milioni.',
            },
        },
        title: 'A quanto ammonta l’importo di costruzione?',
    },
    app: {
        title: 'Baloise assicurazione costruzioni',
    },
    overview: {
        print: {
            label: 'Stampare l’offerta',
        },
        hint: {
            text: 'In caso di domande siamo raggiungibili al E-mail <a href="mailto:easyconstruct@baloise.ch">easyconstruct@baloise.ch</a>.',
        },
        title: 'L’offerta in dettaglio',
    },
    easteregg: {
        message: 'Un prodotto felice del Bets-Team',
    },
};
